import React from 'react';

import { MinimalRecordDetails } from '../../Models';
import tr from '../../../localization/translate';

import recordsBadge from '../../../assets/images/records-exist.svg';
import noRecordsBadge from '../../../assets/images/all-good-badge.svg';

import './RecordsAndBadges.scss';

export default function RecordsAndBadges({ details }) {
  const badge = (details.records > 0) ? recordsBadge : noRecordsBadge;
  const trData = {
    count: details.records,
    date: details.date.format('l')
  };

  const html = (details.records > 0) ?
    tr('matching.about_tenant.credit_check_report_records', trData) :
    tr('matching.about_tenant.credit_check_report_no_records', trData);

  return (
    <div styleName="container">
      <img role="presentation" styleName="badge" src={badge} />
      <p
        className="text"
        dangerouslySetInnerHTML={{ __html: html }} // eslint-disable-line react/no-danger
      />
    </div>
  );
}

RecordsAndBadges.propTypes = {
  details: MinimalRecordDetails.propType.isRequired
};
